'use client';

import dynamic from 'next/dynamic';

const injectToolBar = process.env.LOCAL_TOOLBAR_ENABLED === '1';
const rumEnabled = process.env.RUM_ENABLED === '1';

const DebugBearScript = rumEnabled
  ? dynamic(() => import('scripts/debug-bear'), { ssr: false })
  : null;

const DDPToolbar = injectToolBar
  ? dynamic(() => import('@bedrock/core/vercel/toolbar'), { ssr: false })
  : null;

export default function ThirdPartyProviders() {
  return (
    <>
      {DebugBearScript ? <DebugBearScript /> : null}
      {DDPToolbar ? <DDPToolbar /> : null}
    </>
  );
}
